module.exports = __webpack_public_path__ + "img/logo-mb.094ada1e.png";